<template>
  <div>
    <page-header title="Locations" />
    <div class="section">
      <div class="container max-width-mobile">
        <location-selector
          :selectable="false"
          show-store-info
          show-all-stores
          show-search
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LocationListPage'
  };
</script>
